import { operations, paths } from "./generated-types";
import createClient from "openapi-fetch";
import {
  requestIdMiddleware,
  sessionTokenMiddleware,
} from "@wiesinghilker/extension-lib-frontend";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
  credentials: "include",
});

client.use(sessionTokenMiddleware);
client.use(requestIdMiddleware);

export const getProject = (params: operations["project.get"]["parameters"]) => {
  return client.GET("/projects/{projectId}", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const getImageCompressionSettings = (
  params: operations["appinstallation.get-image-compression-settings"]["parameters"],
) => {
  return client.GET(
    "/projects/{projectId}/appinstallations/{appInstallationId}/image-compression",
    { params, signal: AbortSignal.timeout(2000) },
  );
};

export const updateImageCompressionSettings = (
  body: operations["appinstallation.update-image-compression-settings"]["requestBody"]["content"]["application/json"],
  params: operations["appinstallation.update-image-compression-settings"]["parameters"],
) => {
  return client.PUT(
    "/projects/{projectId}/appinstallations/{appInstallationId}/image-compression",
    { body, params, signal: AbortSignal.timeout(6000) },
  );
};

export const deleteImageCompressionCache = (
  params: operations["deleteImageCompressionCache"]["parameters"],
) => {
  return client.DELETE(
    "/projects/{projectId}/appinstallations/{appInstallationId}/image-compression/cache",
    { params, signal: AbortSignal.timeout(10000) },
  );
};

export const getImageCompressionCacheStats = (
  params: operations["getImageCompressionCacheStats"]["parameters"],
) => {
  return client.GET(
    "/projects/{projectId}/appinstallations/{appInstallationId}/image-compression/cache/stats",
    { params, signal: AbortSignal.timeout(4000) },
  );
};

export const getImageCompressionCacheFiles = (
  params: operations["getImageCompressionCacheFiles"]["parameters"],
) => {
  return client.GET(
    "/projects/{projectId}/appinstallations/{appInstallationId}/image-compression/cache/files",
    { params, signal: AbortSignal.timeout(4000) },
  );
};
